module.exports = __webpack_public_path__ + "static/media/logo-full-lightgrey.cdef815b.svg";